export const blogTypes = {
    tutorial: "Tutorial",
    review: "Review",
    manual: "Manual"
};
